import {
  SubscriptionBadge,
  SubscriptionBadgeProps
} from "views/renters/components/Table/SubscriptionBadge";
import FailedIcon from "shared/icons/status-icons/fail-icon.svg?react";
import SyncIcon from "shared/icons/syncCircle.svg?react";

import { Home02 } from "untitledui-js-base";
import { AlgoliaUser } from "views/renters/types";

type Props = {
  selectedRowData: AlgoliaUser;
};

export const StatusDetails = ({ selectedRowData }: Props) => {
  const { boomEnrollmentStatus } = selectedRowData;

  return (
    <div className="flex flex-col gap-4 overflow-y-auto">
      <div className="flex w-full items-center justify-between pb-2">
        <div className="flex flex-col gap-2">
          <p className="text-sm font-medium text-content-300">
            Subscription status
          </p>
          <div className="w-fit">
            <SubscriptionBadge
              status={boomEnrollmentStatus as SubscriptionBadgeProps["status"]}
            />
          </div>
        </div>

        {/* {boomEnrollmentStatus !== "error" && (
          <div className="flex flex-col gap-2">
            <p className="text-sm font-medium text-content-300">
              Account status
            </p>
            <div className="w-fit">
              <SubscriptionBadge
                status={
                  boomEnrollmentStatus as SubscriptionBadgeProps["status"]
                }
              />
            </div>
          </div>
        )} */}

        {/* TODO HIDDEM UNTILL WE HAVE A WAY TO MANAGE SUBSCRIPTIONS */}
        {/* <div>
          <Button variant={ButtonVariant.PRIMARY} size={ButtonSize.SM}>
            {boomEnrollmentStatus === "error"
              ? "Subscribe"
              : "Manage Subscription"}
          </Button>
        </div> */}
      </div>

      {boomEnrollmentStatus === "error" && (
        <div className="flex w-full flex-col">
          <div className="flex w-full flex-col gap-2 rounded-t-lg border border-alpha-40 bg-danger-50 p-5">
            {(selectedRowData.errorMessage.includes(", current")
              ? selectedRowData.errorMessage.replace(", current", "@current")
              : selectedRowData.errorMessage
            )
              .split(", ")
              .map((error) => {
                return (
                  <div key={error} className="flex items-center gap-2">
                    <FailedIcon className="h-4 w-4 stroke-danger-500" />
                    <p className="text-xs font-medium text-danger-600">
                      {error.includes("@current")
                        ? error.replace("@current", ", current")
                        : error}
                    </p>
                  </div>
                );
              })}
          </div>
          <div className="flex items-center gap-4 rounded-b-lg border border-alpha-40 p-5">
            <div className="flex items-center">
              <Home02 size="32" />
              <div className="relative">
                <SyncIcon className="h-4.5 w-4.5 absolute -left-3" />
              </div>
            </div>

            <p className="text-sm font-medium text-content-1000">
              Please update the renter details in your PMS and try to subscribe
              again when the data is synchronized
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
